import { useMySchool } from '../context/MySchoolContext';

/** @deprecated Prefer useMySchool() from MySchoolContext */
export function useMySchoolProfile() {
  const { school, hasProfile, loading } = useMySchool();
  return { school, hasProfile, loading };
}
